import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BarComponent } from './component/bar/bar.component';
import { SectionComponent } from './component/section/section.component';

@NgModule({
    declarations: [BarComponent, SectionComponent],
    exports: [BarComponent],
    imports: [CommonModule],
})
export class CmpsReportBuilderSelectionModule {}
